module.exports = __webpack_public_path__ + "static/media/neighbourhood_rendering.6e77fcfa.jpg";